import AccountDelete from './AccountDelete'

export default AccountDelete
